import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zjgl",
  "use": "icon-zjgl-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-zjgl\"><path fill=\"#fff\" fill-opacity=\".8\" d=\"M13.75 2.5v3.75h5V17.5H1.25v-15zM10 7.5l-7.8-.406.3 4.781-.3 4.729 7.8-.354 7.791.354-.291-4.729.18-4.781zM7.5 3.75l-5.3-.442L2.5 5l-.3 1.63 5.3-.38 5.315.38L12.5 5l.315-1.692z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol